import { createSelector } from 'reselect';
import { flow, get, getOr } from 'lodash/fp';
import { getMetaOrigin } from 'helpers/meta';

export default (getCms) =>
  createSelector(
    (state, props) => get(['location', 'pathname'], props),
    flow(getCms, getOr('', ['meta-canonical'])),
    (pathname, canonical) => {
      if (canonical === '#') {
        return '';
      }

      if (canonical) {
        return canonical;
      }

      return `${getMetaOrigin()}${pathname}`;
    },
  );
